document.addEventListener("DOMContentLoaded", function () {
    var colorfulElements = document.querySelectorAll(".t-commonTitle");

    colorfulElements.forEach(function (element) {
        var text = element.textContent.trim();
        var spannedText = "";
        for (var i = 0; i < text.length; i++) {
            spannedText += "<span>" + text[i] + "</span>";
        }
        element.innerHTML = spannedText;
    });
});